<template>
  <div class="m-0 dbozone-font bg-squidgame" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-squidgame">
        <section class="d-flex p-2">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang} -squidgame`"
          >
            {{ $t("squidtoon.name") }}
          </h5>
        </section>
      </div>
      <div class="d-flex inline-text" v-for="(text, index) in textList" :key="index" >
        <div v-if="index===2">
          <div v-if="lang==='zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_2`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_2`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
        </div>
        <div v-else>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>
    </div>

    <div
      class="container d-flex flex-column justify-content-center"
      style="margin-top: 2rem"
    >
      <div class="d-flex flex-column nav-squidgame">
        <section class="d-flex p-2">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang} -squidgame`"
          >
            {{ $t("bonusGameBuy.title") }}
          </h5>
        </section>
      </div>
      <div class="d-flex inline-text">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("bonusGameBuy.text1")
        }}</span>
      </div>
      <div class="d-flex inline-text">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("bonusGameBuy.text2")
        }}</span>
      </div>
    </div>

    <div
      class="container d-flex flex-column justify-content-center"
      style="margin-top: 2rem"
    >
      <div class="d-flex flex-column nav-squidgame">
        <section class="d-flex">
          <h5
            class="font-weight-bold m-0 text-title"
            :class="`-${lang} -squidgame`"
          >
            {{ $t("main-game.title") }}
          </h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img   :src="require(`../../assets/ruleGames/main/wallet_icon.png`)"  alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{ $t("main-game.wallet-balance")}}</span>
          </div>
        </div>
        <div class="col-9 c-9-row" style="padding-top: 5%;" >
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-wallet") }}</span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/betamount_icon.svg`)"  alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.bet-amount")}}</span>
          </div>
        </div>
        <div class="col-9 c-9-row">
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-bet1") }}</span>
          </div>
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-bet2") }}</span>
          </div>
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-bet3") }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/win_icon.svg`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{ $t("main-game.win-amount") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"  style="padding-top: 7%;" >
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-win-amount") }}</span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/spin_btn.png`)" alt="" style="display:block;margin:auto; width:60%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.spin") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"  >
          <div>
            <span class="text-sub inline-text " :class="`-${lang}`">{{  $t("main-game.text-spin1") }}</span>
          </div>
          <div>
            <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-spin2")}}</span>
          </div>
          <div>
            <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-spin3")}}</span>
          </div>
          <div>
            <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-spin4")}}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img  :src="require(`../../assets/ruleGames/squidgame/stop_btn.png`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.stop") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-stop") }}</span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/minus_btn.png`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{ $t("main-game.minus") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-minus") }}</span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img  :src="require(`../../assets/ruleGames/squidgame/plus_btn.png`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.plus") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-plus") }}</span>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/autospin_btn.png`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.autospin") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-auto1")}}</span>
          </div>
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-auto2")}}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/menu_btn.png`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.menu") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{  $t("main-game.text-menu") }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img  :src="require(`../../assets/ruleGames/squidgame/quit_icon.svg`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{ $t("main-game.quit") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-quit") }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img  :src="require(`../../assets/ruleGames/squidgame/info_icon.svg`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{ $t("main-game.pay-info") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-info") }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/paytable_icon.svg`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.info-paytable") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-paytable") }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img :src="require(`../../assets/ruleGames/squidgame/history_icon.svg`)" alt="" style="display:block;margin:auto; width:40%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text " :class="`-${lang}`" style="display:contents">{{  $t("main-game.history") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-history") }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img  :src="require(`../../assets/ruleGames/squidgame/option_icon.svg`)" alt="" style="display:block;margin:auto; width:30%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{   $t("main-game.setting") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-setting") }}</span>
          </div>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex flex-row c-12-row" >
        <div class="col-4 align-items-center c-3-row" >
          <div class="align-items-center" >
            <img  :src="require(`../../assets/ruleGames/squidgame/close_icon.svg`)" alt="" style="display:block;margin:auto; width:30%;"/>
          </div>
          <div class="align-items-center" style="text-align: center;" >
            <span class="text-sub inline-text" :class="`-${lang}`" style="display:contents">{{  $t("main-game.close") }}</span>
          </div>
        </div>
        <div class="col-9 c-9-row"   >
          <div>
          <span class="text-sub inline-text " :class="`-${lang}`">{{ $t("main-game.text-close") }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "rule-squidgame",
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      textList: [
        "squidtoon.text-rule1",
        "squidtoon.text-rule2",
        "squidtoon.text-rule3",
        "bonuslock.text-rule4",
        "bonuslock.text-rule5",
        "bonuslock.text-rule6",
        "bonuslock.text-rule7",
        "bonuslock.text-rule8",
        "bonuslock.text-rule9",
        "bonuslock.text-rule10",
        "bonuslock.text-rule11",
        "bonuslock.text-rule12",
        "bonuslock.text-rule13",
      ],
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
    };
  },
};
</script>

<style>
.bg-squidgame {
  background: #E11A70;
}

.nav-squidgame {
  background: #F44786;
  border-radius: 20px;
}
.inline-text {
  line-height: 1;
  padding: 6px;
}
.c-12-row{
    margin: 8px 0px;
    padding: 8px 0px;
}
.c-3-row{
    padding: 0px;
}
.c-9-row{
    padding-right: 0px;
}
</style>